import { useIsMobile } from '@stores/AppCommonData';
import { useEffect, useState } from 'react';

const useKeyboardState = () => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!isMobile || typeof window === 'undefined') return;

    const initialHeight = window.visualViewport?.height || window.innerHeight;

    const handleResize = () => {
      const currentHeight = window.visualViewport?.height || window.innerHeight;
      const heightDifference = initialHeight - currentHeight;
      setIsKeyboardOpen(heightDifference > 150);
    };

    const handleVisualViewportResize = () => {
      if (window.visualViewport) {
        const heightDifference = initialHeight - window.visualViewport.height;
        setIsKeyboardOpen(heightDifference > 150);
      }
    };

    window.addEventListener('resize', handleResize);
    window.visualViewport?.addEventListener(
      'resize',
      handleVisualViewportResize
    );

    return () => {
      window.removeEventListener('resize', handleResize);
      window.visualViewport?.removeEventListener(
        'resize',
        handleVisualViewportResize
      );
    };
  }, [isMobile]);

  return isKeyboardOpen;
};

export default useKeyboardState;
